import { render } from "./NewConditionForm.vue?vue&type=template&id=2daecc02&ts=true"
import script from "./NewConditionForm.vue?vue&type=script&lang=ts"
export * from "./NewConditionForm.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__